module.exports = __webpack_public_path__ + "fonts/Montserrat-Italic.93b74027.WOFF";